<!--<template>-->
<!--  <div>-->
<!--    <div class="flex justify-between mb-4">-->
<!--      <p class="font-medium">MESSAGES</p>-->
<!--      <input-->
<!--          type="text"-->
<!--          v-model="searchTerm"-->
<!--          placeholder="Search messages..."-->
<!--          class="px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"-->
<!--      />-->
<!--    </div>-->

<!--    <div class="border rounded-lg shadow-sm bg-white">-->
<!--      <div v-if="filteredMessages.length > 0" class="overflow-x-auto">-->
<!--        <table class="min-w-full bg-white rounded-lg shadow-md">-->
<!--          <tbody>-->
<!--          <tr-->
<!--              v-for="message in filteredMessages"-->
<!--              :key="message.id"-->
<!--              class="border-t hover:bg-gray-50 transition"-->
<!--          >-->
<!--            <td class="px-6 py-4">-->
<!--              <p class="text-gray-400">{{ message.sender }}</p>-->
<!--              <div>-->
<!--                <strong class="ml-1">{{ message.subject }}</strong>-->
<!--              </div>-->
<!--            </td>-->

<!--            <td class="px-6 py-4 relative flex justify-end">-->
<!--              <p class="px-6 py-4 text-sm text-gray-500">-->
<!--                {{ formatDate(message.created_at) }}-->
<!--              </p>-->
<!--              <button-->
<!--                  @click="openMenu(message.id)"-->
<!--                  class="text-xl text-primary"-->
<!--              >-->
<!--                ⋮-->
<!--              </button>-->
<!--              <div-->
<!--                  v-if="activeMenu === message.id"-->
<!--                  class="absolute right-0 mt-2 w-32 bg-white border border-gray-300 rounded shadow-md z-10"-->
<!--              >-->
<!--                <button-->
<!--                    class="block w-full text-left px-4 py-2 hover:bg-gray-100"-->
<!--                    @click="reply(message.id)"-->
<!--                >-->
<!--                  Reply-->
<!--                </button>-->
<!--                <button-->
<!--                    class="block w-full text-left px-4 py-2 hover:bg-gray-100 text-red-500"-->
<!--                    @click="archiveMessage(message.id)"-->
<!--                >-->
<!--                  Archive-->
<!--                </button>-->
<!--              </div>-->
<!--            </td>-->
<!--          </tr>-->
<!--          </tbody>-->
<!--        </table>-->
<!--      </div>-->

<!--      <div v-else class="p-4 text-gray-500">No messages found.</div>-->
<!--    </div>-->
<!--  </div>-->
<!--</template>-->

<!--<script setup>-->
<!--import { ref, onMounted, computed } from "vue"-->
<!--import api from "@/services/api";-->

<!--const messages = ref([])-->
<!--const searchTerm = ref("")-->
<!--const activeMenu = ref(null)-->

<!--const fetchMessages = async () => {-->
<!--  const res = await api.get("/messages", {-->
<!--    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },-->
<!--  })-->
<!--  messages.value = res.data-->
<!--}-->

<!--const archiveMessage = async (id) => {-->
<!--  console.log("archive called");-->
<!--  await api.post(-->
<!--      `/messages/${id}/archive`,-->
<!--      {},-->
<!--      { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }-->
<!--  )-->
<!--  fetchMessages()-->
<!--}-->


<!--const filteredMessages = computed(() => {-->
<!--  if (!searchTerm.value) return messages.value-->
<!--  return messages.value.filter(-->
<!--      (m) =>-->
<!--          (m.sender?.toLowerCase() || "").includes(searchTerm.value.toLowerCase()) ||-->
<!--          (m.subject?.toLowerCase() || "").includes(searchTerm.value.toLowerCase())-->
<!--  )-->
<!--})-->


<!--function formatDate(dateString) {-->
<!--  const options = { year: "numeric", month: "short", day: "numeric" }-->
<!--  return new Date(dateString).toLocaleDateString(undefined, options)-->
<!--}-->

<!--function openMenu(id) {-->
<!--  activeMenu.value = activeMenu.value === id ? null : id-->
<!--}-->

<!--function reply(id) {-->
<!--  alert(`Reply to message ${id}`)-->
<!--}-->

<!--onMounted(fetchMessages)-->
<!--</script>-->












<!--<template>-->
<!--  <div>-->
<!--    <div class="flex justify-between mb-4">-->
<!--      <p class="font-medium">MESSAGES</p>-->
<!--      <input-->
<!--          type="text"-->
<!--          v-model="searchTerm"-->
<!--          placeholder="Search messages..."-->
<!--          class="px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"-->
<!--      />-->
<!--    </div>-->

<!--    <div class="border rounded-lg shadow-sm bg-white">-->

<!--      <div v-if="filteredMessages.length > 0" class="overflow-x-auto">-->
<!--        <table class="min-w-full bg-white rounded-lg shadow-md">-->
<!--          <tbody>-->
<!--          <tr-->
<!--              v-for="message in filteredMessages"-->
<!--              :key="message.id"-->
<!--              class="border-t hover:bg-gray-50 transition cursor-pointer"-->
<!--              @click="openTicket(message.id)"-->
<!--          >-->
<!--            <td class="px-6 py-4">-->
<!--              <div class="flex items-center gap-2">-->
<!--                &lt;!&ndash; دایره unread &ndash;&gt;-->
<!--                <span-->
<!--                    v-if="!message.is_read"-->
<!--                    class="w-3 h-3 rounded-full bg-red-500 flex-shrink-0"-->
<!--                    title="Unread message"-->
<!--                ></span>-->

<!--                &lt;!&ndash; متن پیام &ndash;&gt;-->
<!--                <div class="flex flex-col">-->
<!--                  <p class="text-gray-400 text-sm">{{ message.sender }}</p>-->
<!--                  <strong class="ml-0 text-gray-800">{{ message.subject }}</strong>-->
<!--                </div>-->
<!--              </div>-->
<!--            </td>-->

<!--            <td class="px-6 py-4 text-sm text-gray-500 text-right">-->
<!--              {{ formatDate(message.created_at) }}-->
<!--            </td>-->
<!--          </tr>-->
<!--          </tbody>-->
<!--        </table>-->
<!--      </div>-->

<!--      <div v-else class="p-4 text-gray-500">No messages found.</div>-->
<!--    </div>-->

<!--    &lt;!&ndash; Modal &ndash;&gt;-->
<!--    <transition name="modal-overlay">-->
<!--      <div-->
<!--          v-if="selectedTicket"-->
<!--          class="fixed inset-0 h-full bg-black/50 flex justify-center items-center z-50"-->
<!--      >-->
<!--        <div class="bg-white dark:bg-gray-900 dark:text-white rounded-lg w-11/12 md:w-3/4 max-w-2xl p-6 relative">-->
<!--          <button-->
<!--              @click="selectedTicket = null"-->
<!--              class="absolute top-2 right-2 text-gray-700 dark:text-gray-300 text-2xl leading-none"-->
<!--          >&times;-->
<!--          </button>-->

<!--          <h2 class="text-xl font-bold mb-4">{{ selectedTicket.subject ?? 'No subject' }}</h2>-->

<!--          <div class="max-h-96 overflow-y-auto mb-4 space-y-2">-->
<!--            <div-->
<!--                v-for="(msg, index) in ticketMessages"-->
<!--                :key="index"-->
<!--                class="p-2 rounded border dark:border-gray-700 bg-gray-50 dark:bg-gray-800"-->
<!--            >-->
<!--              <div class="flex items-baseline justify-between">-->
<!--                <div>-->
<!--                  <span class="font-semibold mr-2">{{ msg.from }}:</span>-->
<!--                  <span>{{ msg.text }}</span>-->
<!--                </div>-->
<!--                <div class="text-xs text-gray-500 ml-4 whitespace-nowrap">-->
<!--                  {{ formatRelative(msg.date) }}-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div v-if="ticketMessages.length === 0" class="text-sm text-gray-500">-->
<!--              No messages yet.-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="flex flex-col gap-2">-->
<!--            <textarea-->
<!--                v-model="replyText"-->
<!--                class="w-full p-2 border rounded dark:bg-gray-800 dark:text-white"-->
<!--                placeholder="Write a reply..."-->
<!--                rows="4"-->
<!--            ></textarea>-->

<!--            <div class="flex gap-2 justify-end">-->
<!--              <button-->
<!--                  @click="selectedTicket = null"-->
<!--                  class="px-3 py-2 border rounded bg-transparent text-sm text-gray-700 hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-white/[0.03]"-->
<!--              >-->
<!--                Cancel-->
<!--              </button>-->

<!--              <button-->
<!--                  @click="sendReply"-->
<!--                  :disabled="!canSend"-->
<!--                  class="px-3 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed text-sm"-->
<!--              >-->
<!--                Send Reply-->
<!--              </button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </transition>-->
<!--  </div>-->
<!--</template>-->

<!--<script setup>-->
<!--import {ref, computed, onMounted} from 'vue'-->
<!--import api from '@/services/api'-->
<!--import dayjs from 'dayjs'-->
<!--import relativeTime from 'dayjs/plugin/relativeTime'-->

<!--dayjs.extend(relativeTime)-->

<!--const messages = ref([])-->
<!--const searchTerm = ref('')-->
<!--const selectedTicket = ref(null)-->
<!--const replyText = ref('')-->

<!--// Fetch messages list-->
<!--const fetchMessages = async () => {-->
<!--  const res = await api.get('/messages', {-->
<!--    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`}-->
<!--  })-->
<!--  console.log("ascdcsqwqw", res);-->
<!--  messages.value = res.data-->
<!--}-->

<!--onMounted(fetchMessages)-->

<!--// Filtering messages-->
<!--const filteredMessages = computed(() => {-->
<!--  if (!searchTerm.value) return messages.value-->
<!--  return messages.value.filter(m =>-->
<!--      (m.sender?.toLowerCase() || '').includes(searchTerm.value.toLowerCase()) ||-->
<!--      (m.subject?.toLowerCase() || '').includes(searchTerm.value.toLowerCase())-->
<!--  )-->
<!--})-->

<!--// Open ticket and fetch replies-->
<!--const ticketMessages = computed(() => {-->
<!--  if (!selectedTicket.value) return []-->
<!--  let msgs = []-->
<!--  if (selectedTicket.value.body) {-->
<!--    msgs.push({-->
<!--      from: selectedTicket.value.sender || 'You',-->
<!--      text: selectedTicket.value.body,-->
<!--      date: selectedTicket.value.created_at-->
<!--    })-->
<!--  }-->
<!--  if (selectedTicket.value.replies?.length) {-->
<!--    selectedTicket.value.replies.forEach(r => {-->
<!--      msgs.push({-->
<!--        from: r.admin?.name || 'Admin',-->
<!--        text: r.reply,-->
<!--        date: r.created_at-->
<!--      })-->
<!--    })-->
<!--  }-->
<!--  return msgs.sort((a, b) => new Date(a.date) - new Date(b.date))-->
<!--})-->

<!--const openTicket = async (id) => {-->
<!--  try {-->
<!--    const res = await api.get(`/messages/${id}`, {-->
<!--      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`}-->
<!--    })-->
<!--    selectedTicket.value = res.data-->
<!--    replyText.value = ''-->
<!--  } catch (err) {-->
<!--    console.error(err)-->
<!--    alert('Failed to load ticket')-->
<!--  }-->
<!--}-->

<!--const canSend = computed(() => replyText.value.trim().length > 0)-->

<!--const sendReply = async () => {-->
<!--  if (!selectedTicket.value || !replyText.value.trim()) return-->

<!--  try {-->
<!--    const res = await api.post(-->
<!--        `/messages/${selectedTicket.value.id}/reply`,-->
<!--        {reply: replyText.value.trim()},-->
<!--        {headers: {Authorization: `Bearer ${localStorage.getItem('token')}`}}-->
<!--    )-->
<!--    if (!selectedTicket.value.replies) selectedTicket.value.replies = []-->
<!--    selectedTicket.value.replies.push(res.data)-->
<!--    replyText.value = ''-->
<!--  } catch (err) {-->
<!--    console.error(err)-->
<!--    alert('Failed to send reply')-->
<!--  }-->
<!--}-->

<!--function formatDate(dateString) {-->
<!--  return new Date(dateString).toLocaleDateString(undefined, {year: 'numeric', month: 'short', day: 'numeric'})-->
<!--}-->

<!--const formatRelative = (date) => dayjs(date).fromNow()-->
<!--</script>-->


<template>
  <div>
    <!-- Header: Messages + Search -->
    <div class="flex justify-between mb-4">
      <p class="font-medium">MESSAGES</p>
      <input
          type="text"
          v-model="searchTerm"
          placeholder="Search messages..."
          class="px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
      />
    </div>

    <!-- Messages list -->
    <div class="border rounded-lg shadow-sm bg-white">
      <div v-if="filteredMessages.length > 0" class="overflow-x-auto">
        <table class="min-w-full bg-white rounded-lg shadow-md">
          <tbody>
          <tr
              v-for="message in filteredMessages"
              :key="message.id"
              class="border-t hover:bg-gray-50 transition cursor-pointer"
              @click="openTicket(message.id)"
          >
            <td class="px-6 py-4 flex items-center justify-between">
              <!-- Clickable message area -->
              <div class="flex items-center gap-2">
                <!-- unread circle -->
                <span
                    v-if="!message.is_read"
                    class="w-3 h-3 rounded-full bg-red-500 flex-shrink-0"
                    title="Unread message"
                ></span>
                <!-- sender & subject -->
                <div class="flex flex-col">
                  <p class="text-gray-400 text-sm">{{ message.sender }}</p>
                  <strong class="ml-0 text-gray-800">{{ message.subject }}</strong>
                </div>
              </div>

              <!-- Options menu -->
<!--              <div class="relative">-->
<!--                <button-->
<!--                    @click.stop="toggleMenu(message.id)"-->
<!--                    class="text-xl text-primary"-->
<!--                    title="Options"-->
<!--                >-->
<!--                  ⋮-->
<!--                </button>-->
<!--                <div-->
<!--                    v-if="activeMenu === message.id"-->
<!--                    class="absolute right-0 mt-2 w-32 bg-white border border-gray-300 rounded shadow-md z-10"-->
<!--                >-->
<!--                  <button-->
<!--                      class="block w-full text-left px-4 py-2 hover:bg-gray-100"-->
<!--                      @click.stop="reply(message.id)"-->
<!--                  >-->
<!--                    Reply-->
<!--                  </button>-->
<!--                  <button-->
<!--                      class="block w-full text-left px-4 py-2 hover:bg-gray-100 text-red-500"-->
<!--                      @click.stop="archiveMessage(message.id)"-->
<!--                  >-->
<!--                    Archive-->
<!--                  </button>-->
<!--                </div>-->
<!--              </div>-->

              <p class="px-6 py-4 text-sm text-gray-500 text-right">
                {{ formatDate(message.created_at) }}
              </p>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div v-else class="p-4 text-gray-500">No messages found.</div>
    </div>

    <!-- Modal -->
    <transition name="modal-overlay">
      <div
          v-if="selectedTicket"
          class="fixed inset-0 h-full bg-black/50 flex justify-center items-center z-50"
      >
        <div class="bg-white dark:bg-gray-900 dark:text-white rounded-lg w-11/12 md:w-3/4 max-w-2xl p-6 relative flex flex-col max-h-[80vh]">
          <!-- Close button -->
          <button
              @click="selectedTicket = null"
              class="absolute top-2 right-2 text-gray-700 dark:text-gray-300 text-2xl leading-none"
          >&times;</button>

          <h2 class="text-xl font-bold mb-4">{{ selectedTicket.subject ?? 'No subject' }}</h2>

          <!-- Messages container -->
          <div ref="messagesContainer" class="overflow-y-auto mb-4 space-y-2 flex-1">
            <div
                v-for="(msg, index) in ticketMessages"
                :key="index"
                class="p-2 rounded border dark:border-gray-700 bg-gray-50 dark:bg-gray-800"
            >
              <div class="flex items-baseline justify-between">
                <div>
                  <span class="font-semibold mr-2">{{ msg.from }}:</span>
                  <span>{{ msg.text }}</span>
                </div>
                <div class="text-xs text-gray-500 ml-4 whitespace-nowrap">{{ formatRelative(msg.date) }}</div>
              </div>
            </div>

            <div v-if="ticketMessages.length === 0" class="text-sm text-gray-500">
              No messages yet.
            </div>
          </div>

          <!-- Reply + Archive -->
          <div class="flex flex-col gap-2">
            <textarea
                v-model="replyText"
                class="w-full p-2 border rounded dark:bg-gray-800 dark:text-white"
                placeholder="Write a reply..."
                rows="4"
            ></textarea>

            <div class="flex gap-2 justify-between">
              <button
                  @click="archiveTicket"
                  class="px-3 py-2 border rounded bg-red-500 text-white hover:bg-red-600 text-sm"
              >
                Archive
              </button>

              <div class="flex gap-2">
                <button
                    @click="selectedTicket = null"
                    class="px-3 py-2 border rounded bg-transparent text-sm text-gray-700 hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-white/[0.03]"
                >
                  Cancel
                </button>

                <button
                    @click="sendReply"
                    :disabled="!canSend"
                    class="px-3 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
                >
                  Send Reply
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, nextTick, watch } from 'vue'
import api from '@/services/api'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

const messages = ref([])
const searchTerm = ref('')
const selectedTicket = ref(null)
const replyText = ref('')
// const activeMenu = ref(null)
const messagesContainer = ref(null)

// Fetch messages
const fetchMessages = async () => {
  const res = await api.get('/messages', {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  })
  messages.value = res.data
}

// Filtered messages
const filteredMessages = computed(() => {
  if (!searchTerm.value) return messages.value
  return messages.value.filter(m =>
      (m.sender?.toLowerCase() || '').includes(searchTerm.value.toLowerCase()) ||
      (m.subject?.toLowerCase() || '').includes(searchTerm.value.toLowerCase())
  )
})

// Ticket messages
const ticketMessages = computed(() => {
  if (!selectedTicket.value) return []
  let msgs = []
  if (selectedTicket.value.body) {
    msgs.push({
      from: selectedTicket.value.sender || 'You',
      text: selectedTicket.value.body,
      date: selectedTicket.value.created_at
    })
  }
  if (selectedTicket.value.replies?.length) {
    selectedTicket.value.replies.forEach(r => {
      msgs.push({
        from: r.admin?.name || 'Admin',
        text: r.reply,
        date: r.created_at
      })
    })
  }
  return msgs.sort((a, b) => new Date(a.date) - new Date(b.date))
})

// Scroll to bottom on new messages
watch(ticketMessages, async () => {
  await nextTick()
  if (messagesContainer.value) {
    messagesContainer.value.scrollTop = messagesContainer.value.scrollHeight
  }
})

const openTicket = async (id) => {
  try {
    const res = await api.get(`/messages/${id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
    selectedTicket.value = res.data
    replyText.value = ''
  } catch (err) {
    console.error(err)
    alert('Failed to load ticket')
  }
}

const canSend = computed(() => replyText.value.trim().length > 0)

// Send reply
const sendReply = async () => {
  if (!selectedTicket.value || !replyText.value.trim()) return

  try {
    const res = await api.post(
        `/messages/${selectedTicket.value.id}/reply`,
        { reply: replyText.value.trim() },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
    )
    if (!selectedTicket.value.replies) selectedTicket.value.replies = []
    selectedTicket.value.replies.push(res.data)
    replyText.value = ''
  } catch (err) {
    console.error(err)
    alert('Failed to send reply')
  }
}

// Archive from list
// const archiveMessage = async (id) => {
//   try {
//     await api.post(`/messages/${id}/archive`, {}, {
//       headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
//     })
//     fetchMessages()
//   } catch (err) {
//     console.error(err)
//     alert('Failed to archive')
//   }
// }

// Archive from modal
const archiveTicket = async () => {
  if (!selectedTicket.value) return
  try {
    await api.post(`/messages/${selectedTicket.value.id}/archive`, {}, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
    selectedTicket.value = null
    fetchMessages()
  } catch (err) {
    console.error(err)
    alert('Failed to archive')
  }
}

// Menu toggle
// const toggleMenu = (id) => {
//   activeMenu.value = activeMenu.value === id ? null : id
// }

// Reply from menu
// const reply = (id) => {
//   openTicket(id)
// }

function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })
}

const formatRelative = (date) => dayjs(date).fromNow()

onMounted(fetchMessages)
</script>
